import client from '@lib/http/client'

export interface ResetLandingRequest {
  uuid: string
}

export const resetLanding = ({ uuid }: ResetLandingRequest) =>
  client.post(`landing-page/landings/${uuid}/stats-reset`)
